import type { ComponentType, FC } from "react";
import { memo } from "react";

import { defaultToTrue } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

import {
    type INavigationModal,
    type INavigationModalActions,
    NavigationModal,
} from "../common/NavigationModal";
import { type INavigationSuccessPage, NavigationSuccessPage } from "../common/NavigationSuccessPage";
import { CashbackClaimForm, type ICashbackClaimForm } from "./CashbackClaimForm";
import { CashbackClaimSummary, type ICashbackClaimSummary } from "./CashbackClaimSummary";
import { CashbackClaimWrongDate } from "./CashbackClaimWrongDate";
import { AvailabilityState, type ICashbackClaimFields } from "./CashbackCommonInterfaces";
import { CashbackMissingClaimForm, type ICashbackMissingClaimForm } from "./CashbackMissingClaimForm";

const styles = stylex.create({
    container: { height: "100%", width: "100%" },
});

export interface ICashbackClaim {
    step1: ICashbackClaimForm;
    step1Missing: ICashbackMissingClaimForm;
    step2: ICashbackClaimSummary;
    step3: INavigationSuccessPage;
    fields: ICashbackClaimFields;
    navigationModal: INavigationModal;
}

const CashbackClaim: FC<ICashbackClaim> = memo((props) => {
    let WrapperNavigationModal: ComponentType<INavigationModal>;

    switch (props.fields && props.fields.availability) {
        case AvailabilityState.Approved:
        case AvailabilityState.Pending:
            WrapperNavigationModal = NavigationModal(
                [CashbackClaimForm, CashbackClaimSummary, NavigationSuccessPage],
                [props.step1, props.step2, props.step3],
                props.fields,
            );
            break;
        case AvailabilityState.Rejected:
            WrapperNavigationModal = NavigationModal(
                [CashbackClaimSummary, NavigationSuccessPage],
                [props.step2, props.step3],
                props.fields,
            );
            break;
        default:
            WrapperNavigationModal = NavigationModal<
                ICashbackClaimFields,
                INavigationModalActions<ICashbackClaimFields>
            >(
                [
                    CashbackMissingClaimForm,
                    CashbackClaimWrongDate,
                    CashbackClaimSummary,
                    NavigationSuccessPage,
                ],
                [props.step1Missing, {}, props.step2, props.step3],
                props.fields,
            );
            break;
    }

    return (
        <div {...stylex.props(styles.container)}>
            <WrapperNavigationModal {...props.navigationModal} allowBodyScroll={false} />
        </div>
    );
}, defaultToTrue);

export default CashbackClaim;
